import vuex from "src/vuex";
import _ from "lodash";

export default {
  install(Vue, options) {
    Vue.prototype.$hasRole = function (role) {
      return vuex.getters.getRole.indexOf(role) !== -1;
    };
    Vue.prototype.$hasAnyRole = function (roles) {
      if (Array.isArray(roles) === false || roles.length === 0) {
        return true;
      }
      for (let i = 0; i < roles.length; i++) {
        if (this.$hasRole(roles[i])) {
          return true;
        }
      }

      return false;
    };
    Vue.prototype.$can = function (permission) {
      return vuex.getters.getPermissions.indexOf(permission) !== -1;
    };
    Vue.prototype.$hasModule = function (module) {
      let permissions = vuex.getters.getPermissions;
      let hasModule = false;
      for (let permission of permissions) {
        if (permission.search(module + "__") !== -1) {
          hasModule = true;
        }
      }
      return hasModule;
    }
    Vue.prototype.$canAny = function (permissions) {
      if (Array.isArray(permissions) === false || permissions.length === 0) {
        return true;
      }
      for (let i = 0; i < permissions.length; i++) {
        if (this.$can(permissions[i])) {
          return true;
        }
      }

      return false;
    };
    Vue.prototype.$hasPlanOrBetter = function (plan) {
      let plans = vuex.getters.getPlans;
      for (let CompanyPlan of plans) {
        if ((CompanyPlan === plan) || CompanyPlan.split("__")[1] > plan.split("__")[1]) {
          return true
        }
      }
      return false
    };
    Vue.prototype.$hasFeature = function (feature) {
      return vuex.getters.getCompanyFeatures.indexOf(feature) !== -1;
    }
  }
};
